<template>
    <div class="f-row-l">
        <div v-for="(item, index) in files" :key="index" class="upload_imgbox" :title="item.name ? item.url.substring(imageUrl.length * 1 + 5, item.url.length) : ''" >
            <el-image class="upload_img"
            :src="item.url"
            fit="cover" v-if='type=="cid"||type=="license"'
            ></el-image>
            <span v-else>{{item.url.substring(imageUrl.length * 1 + 5, item.url.length)}}</span>
            <div class="iconbox">
            <i class="el-icon-view" @click.stop="handleView(item)"></i>
            <i class="el-icon-delete" size='26' @click.stop="pimgRemove(index)"></i>
            </div>
        </div>
        <el-upload action="#" 
        v-if='show' :show-file-list="false" :auto-upload="false"
        ref="upload" :on-change='httpRequest'
        :limit="len" :before-remove="pimgRemove" :on-error="pimgError" :file-list="files" :list-type='type=="cid"||type=="license"?"picture-card":"text"'>
            <el-image fit='cover' v-if='type=="cid"&&len>files.length' class="upload_img" :src="require('@/assets/newimg/upload.png')" alt=""></el-image>
            <el-image fit='cover' v-if='type=="license"&&len>files.length' class="upload_img" :src="require('@/assets/newimg/upload2.png')" alt="" ></el-image>
            <div v-if='type=="file"&&len>files.length' class="upload_btn" size="small" type="danger">点击上传</div>
        </el-upload>
       <el-image-viewer title="View Image" v-if="visible" :on-close="onclose" :url-list="imgName"/>
    </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
    components: { ElImageViewer },
    props:['type','len','fileList'],
    name: '',
    computed:{ 
        fileStr:function(){ 
            this.fileListSave=this.fileList;
            console.log(111,this.fileList)
            if(this.fileList){ 
                return this.fileList
            }else{ 
                return ''
            }
        }
    },
    data() {
        return {
            show:true,
            baseUrl:this.$localUrl,
            fileListSave:'',
            files:[],
            imgName: [],
            visible: false,
        };
    },

    mounted() {
        // console.log('222',this.files)
        
    },
    watch:{ 
        fileStr:{
            handler(newVal){ 
                this.getFile(newVal)
            },
            immediate:true
        }
    },
    methods: {
        onclose() {
        this.visible = false;
        },
        handleView(item) {
            this.imgName = [];
            this.files.forEach((k) => {
                if (k) {
                var url = "";
                if (k.url.indexOf("http") == -1) {
                    url = this.getFileAccessHttpUrl(k.url);
                } else {
                    url = k.url;
                }
                this.imgName.push(url);
                }
            });
            console.log(this.imgName);
            this.$nextTick(() => {
                this.visible = true;
            });
        },
        submitUpload(){
            this.$refs.upload.submit()
        },
        getFile(newVal){ 
            var str=newVal
            var filesArr=[]
            // this.files=[]
            if(str){ 
                str.split(',').forEach((k,kind)=>{ 
                    var url=this.getFileAccessHttpUrl(k);
                    var arr=k?k.split('/'):[]
                    var name=arr.length>0?arr[arr.length-1]:''
                    filesArr=filesArr.concat([{name:name,url:url}])
                    // this.files.push({name:name,url:url})
                })
            }
            this.$nextTick(()=>{ 
                this.files=JSON.parse(JSON.stringify(filesArr))
            });
            console.log('filesArr',filesArr)
        },
        httpRequest(file){
            var that=this;
            that.show=false;
            var formData = new FormData();//通过form数据格式来传
            formData.append("file", file.raw); //传文件
            this.httpPost("/sys/common/upload",formData).then(res=>{
                var { code,message,success } = res
                if(success){
                   
                    that.show=true;
                    var url=this.getFileAccessHttpUrl(message);
                    var arr=message?message.split('/'):[]
                    var name=arr.length>0?arr[arr.length-1]:''
                    this.fileListSave=this.fileListSave?this.fileListSave+','+url:url
                    this.$message.success('上传成功')
                    this.$emit('success', this.fileListSave);
                }else{
                    this.$message.error(message)
                }
            }).catch(error=>{

            }) 
        },
        // 图片上传成功
        pimgSuccess(e) {},
        // 删除图片
        pimgRemove(index) {
            var that=this;
            var h = this.$createElement;
            that.$msgbox({
            title: '删除',
            message: h('p', null, [
                h('span', null, '此操作将永久删除该文件, '),
                h('span', { style: 'color: #333' }, '是否继续?')
            ]),
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            beforeClose: (action, instance, done) => {
                if (action === 'confirm') {
                    instance.confirmButtonLoading = true;
                    instance.confirmButtonText = '执行中...';
                    setTimeout(() => {
                        setTimeout(() => {
                        instance.confirmButtonLoading = false;
                        that.files.splice(index,1);

                        var str='';
                        if(that.files.length>0){
                            that.files.forEach(k=>{ 
                                if(k){
                                    str=str?(str+','+k.url):k.url
                                }
                                
                            })
                        }
                        
                        that.fileListSave=str
                        console.log('str',str)
                        that.$emit('success', str);
                        done();
                        }, 300);
                    }, 500);
                } else {
                    done();
                }
            }
            }).then(action => {
                that.$store.commit('upAlertBox', {
                    type: true,
                    // time:500,
                    message: action
                });
                return false
            });
            return false
        },
        // 图片上传失败
        pimgError() {},
        },
};
</script>

<style scoped>
.f-row-l{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.upload_imgbox:hover .iconbox{
    display: block;
}
.upload_imgbox{ 
    position: relative;
    display: inline-block;
    margin-right: 10px;
}
.upload_img{
width: 1.37rem;
height: 1.36rem;
}
.iconbox {
  display: none;
  position: absolute;
  right: 0px;
  top:0px;
  z-index: 7;
  background: rgba(0, 0, 0, 0.6);
}
.iconbox i {
  color: #fff;
  cursor: pointer;
  margin: 0 5px;
}
>>>.el-upload--picture-card,
>>>.el-upload-list--picture-card .el-upload-list__item{ 
    width: 1.37rem!important;
    height: 1.36rem!important;
    line-height: 1.36rem!important;
    border: 0px;
}
>>>.el-upload-list--picture-card .el-upload-list__item img{
    height: auto;
    width: 100%;
}
>>>.is-success{
    background: #f4f4f4;
}
>>>.el-icon-upload-success{ 
    position: absolute;
    left: 15px;
}
.upload_btn {
width: 1.1rem;
height: 0.27rem;
background: #ff0000;
border-radius: 0.03rem;
color: #ffffff;
font-size: 0.15rem;
font-weight: 400;
line-height: 0.27rem;
}
.mr-1{ 
    margin-right: 10px;
}
</style>
